import { render, staticRenderFns } from "./list-management-modal-item.vue?vue&type=template&id=60008146&scoped=true&"
import script from "./list-management-modal-item.vue?vue&type=script&lang=ts&"
export * from "./list-management-modal-item.vue?vue&type=script&lang=ts&"
import style0 from "./list-management-modal-item.vue?vue&type=style&index=0&id=60008146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60008146",
  null
  
)

export default component.exports